var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-doc-player",
      class: { "yxtbiz-doc-player--dark": _vm.dark },
    },
    [
      _c(
        _vm.componentName,
        _vm._b(
          { ref: "viewer", tag: "component" },
          "component",
          _vm._props,
          false
        ),
        [
          _c("yxtbiz-watermark", {
            attrs: {
              slot: "watermark",
              version: _vm.watermarkCode ? "v2" : "",
              "app-code": this.watermarkCode,
              option: _vm.watermarkConfig,
            },
            slot: "watermark",
          }),
        ],
        1
      ),
      _c(
        "toolbar",
        {
          attrs: {
            dark: _vm.dark,
            fullscreen: _vm.fullscreen,
            zoom: _vm.zoom,
            toolbars: _vm.toolbars,
          },
          on: {
            "update:dark": function ($event) {
              _vm.dark = $event
            },
            "update:zoom": function ($event) {
              _vm.zoom = $event
            },
            pageChange: _vm.onPageChange,
            scrollToPage: _vm.scrollToPage,
            toggleFullScreen: _vm.toggleFullScreen,
          },
        },
        [_vm._t("operation")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }